import { Button, Flex, Input, Select, Table, Tag } from "antd";
import React from "react";
import { formatDateTime } from "../../../utilities/utils";

const SmsTable = ({
  filters,
  setFilters,
  data,
  loading,
  pagination,
  handleTableChange,
}) => {
  const statusColors = {
    pending: "default", // саарал
    sent: "green", // ногоон
    canceled: "red", // улаан
    failed: "orange", // улбар
  };

  const columns = [
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={statusColors[status] || "default"}
          style={{ textTransform: "capitalize" }}
        >
          {status}
        </Tag>
      ),
    },
    { title: "Хэнд", dataIndex: "to", key: "to" },
    { title: "Текст", dataIndex: "message", key: "message" },
    { title: "Зорилго", dataIndex: "refer", key: "refer" },
    {
      title: "Огноо",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
  ];

  const handleClear = () => {
    setFilters({ to: "", status: null, refer: null });
  };

  return (
    <Flex vertical gap={"15px"}>
      <Flex gap="10px" wrap="wrap">
        <Input
          placeholder="Утас"
          allowClear
          value={filters.to}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, to: e.target.value }))
          }
          style={{ width: 200 }}
        />

        <Select
          placeholder="Төлөв"
          allowClear
          value={filters.status}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, status: value }))
          }
          style={{ width: 150 }}
        >
          <Select.Option value="sent">Амжилттай</Select.Option>
          <Select.Option value="pending">Хүлээгдэж байгаа</Select.Option>
          <Select.Option value="failed">Амжилтгүй</Select.Option>
        </Select>

        <Select
          placeholder="Зорилго"
          allowClear
          value={filters.refer}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, refer: value }))
          }
          style={{ width: 150 }}
        >
          <Select.Option value="ticket">Сугалаа</Select.Option>
          <Select.Option value="call_attempt">Call center</Select.Option>
          <Select.Option value="otp">OTP</Select.Option>
          <Select.Option value="mass">Mass</Select.Option>
        </Select>

        <Button onClick={handleClear}>Цэвэрлэх</Button>
      </Flex>

      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </Flex>
  );
};

export default SmsTable;
